import { Collapse, Group, Text } from "@mantine/core"
import { useDisclosure } from "@mantine/hooks"
import { Badge, BadgeVariant, ToggleCollapse } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import {
  findCertificateRequestsByCertificateIdHttpControllerFindCertificateRequestsByCertificateIdQueryParamsStatusEnum,
  FindCertificateRequestsByCertificateIdItem,
  FindCertificateRequestsByCertificateIdItemGroup,
} from "~/gen/api"
import { CompletedCertificateRequestCard } from "~/pages/Brand/Certificates/components/CompletedCertificateRequestCard"

export type CompletedCertificateRequestsProps = {
  data: FindCertificateRequestsByCertificateIdItemGroup
}

export const CompletedCertificateRequests: React.FC<
  CompletedCertificateRequestsProps
> = ({ data }: CompletedCertificateRequestsProps) => {
  const { t } = useTranslation("certificates")

  const [opened, { toggle: toggle }] = useDisclosure(false)

  if (!data.certificateRequests || data.count === 0) {
    return null
  }

  const badgeVariant =
    data.status ===
    findCertificateRequestsByCertificateIdHttpControllerFindCertificateRequestsByCertificateIdQueryParamsStatusEnum.ACCEPTED
      ? BadgeVariant.SUCCESS
      : BadgeVariant.ERROR

  const seeMoreLabelComponent = (
    <Group gap="xs">
      <Text fw={600} size="md">
        {t(`certificateRequestStatus.${data.status}`)}
      </Text>
      <Badge variant={badgeVariant} text={data.count.toString()} size="xs" />
    </Group>
  )

  return (
    <>
      <ToggleCollapse
        open={opened}
        toggle={toggle}
        seeMoreLabel={seeMoreLabelComponent}
        seeLessLabel={seeMoreLabelComponent}
      />
      <Collapse in={opened}>
        {data.certificateRequests.map(
          (certificateRequest: FindCertificateRequestsByCertificateIdItem) => (
            <CompletedCertificateRequestCard
              key={certificateRequest.id}
              certificateRequest={certificateRequest}
            />
          )
        )}
      </Collapse>
    </>
  )
}
